import { render } from "./DiscussionListModal.vue?vue&type=template&id=b8cc2ea4&scoped=true"
import script from "./DiscussionListModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionListModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionListModal.vue?vue&type=style&index=0&id=b8cc2ea4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cc2ea4"]])

export default __exports__